import { isAppAdmin } from '@ordo/auth'
import { Navigate, Outlet } from 'react-router'
import { useAuthStore } from 'stores/auth'

/**
 * Mounted as the parent route for `/admin/*` and `/inbound/*`. Requires multipass-resolved
 * `comms` ADMIN role on the current user (multipass slug for boombox);
 * non-admins are redirected to Home. Pair with server-side
 * `requireAppRole('comms','ADMIN')` on the matching API routes — client
 * gating is UX, not enforcement.
 */
export function AdminRoute() {
  const user = useAuthStore((s) => s.user)
  if (!isAppAdmin(user, 'comms')) {
    return <Navigate to="/" replace />
  }
  return <Outlet />
}
